const IGNORED_MESSAGE_PATTERNS = [
  /Support for defaultProps will be removed from function components/,
  /findDOMNode is deprecated and will be removed in the next major release/,
];

function isLocalhost(): boolean {
  return (
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1" ||
    window.location.hostname === "socialcoach.localhost"
  );
}

function isIgnored(...args: unknown[]): boolean {
  return args.some(arg => typeof arg === "string" && IGNORED_MESSAGE_PATTERNS.some(pattern => pattern.test(arg)));
}

if (isLocalhost()) {
  for (const method of ["error", "warn"] as const) {
    const original = console[method].bind(console);
    console[method] = (...args: unknown[]) => {
      if (isIgnored(...args)) return;
      original(...args);
    };
  }
}
